import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CONSTANTS, getUtility, Icon } from '@livable/saas-react-components';
import { Accordion, AccordionDetails, AccordionSummary, Button, Chip, Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { monthNames, sortCycles } from 'src/utils/date';
import BillTable from './billTable';
import useCorrectionsDetailsStyles from './styles';
import SummaryTable from '../AdditionalChargesCreditsModal/summaryTable';
const CorrectionsDetailsTable = _ref => {
  var _store$corrections$co, _store$corrections$co2;
  let allocationCycleId = _ref.allocationCycleId,
    correctionSummary = _ref.correctionSummary,
    isExcluded = _ref.isExcluded,
    handleClose = _ref.handleClose;
  const classes = useCorrectionsDetailsStyles();
  const modalFooterClasses = useModalFooterStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const correctionAllocationCycles = ((_store$corrections$co = store.corrections.correctionsDetails.get(allocationCycleId)) === null || _store$corrections$co === void 0 ? void 0 : _store$corrections$co.correctionAllocationCycles) || [];
  const correctionTriggers = ((_store$corrections$co2 = store.corrections.correctionsDetails.get(allocationCycleId)) === null || _store$corrections$co2 === void 0 ? void 0 : _store$corrections$co2.correctionTriggers) || [];
  const notSet = t('allocations.not_set');
  const summaries = ['Bill total', 'Deductions', 'Total billing', 'Service dates', 'Recovery'];
  const transformCycles = c => _objectSpread(_objectSpread({}, c), {}, {
    ym: "".concat(c.year).concat(c.month.toString().padStart(2, '0')) * 1
  });
  const getDate = date => date ? moment(date).format('L') : notSet;
  const getSummaryObj = data => {
    const billEndDateOnly = data.billEndDateOnly,
      billStartDateOnly = data.billStartDateOnly,
      correctedBillAmount = data.correctedBillAmount,
      correctedRecovery = data.correctedRecovery,
      correctedTotalBillAmount = data.correctedTotalBillAmount,
      totalDeductions = data.totalDeductions;
    return {
      'Bill total': "$".concat(correctedBillAmount.toFixed(2)),
      Deductions: "$".concat(totalDeductions.toFixed(2)),
      'Total billing': "$".concat(correctedTotalBillAmount.toFixed(2)),
      'Service dates': "".concat(getDate(billStartDateOnly), " - ").concat(getDate(billEndDateOnly)),
      Recovery: "".concat(correctedRecovery.toFixed(2), "%")
    };
  };
  const getReason = _ref2 => {
    let corrected = _ref2.corrected,
      hasOriginal = _ref2.hasOriginal,
      label = _ref2.label,
      isMoveOut = _ref2.isMoveOut,
      original = _ref2.original;
    return /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      color: "light"
    }, label, hasOriginal ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Chip, {
      className: "".concat(classes.chip, " ").concat(isMoveOut ? '' : classes.correctedChip),
      color: "primary",
      label: original,
      variant: "critical"
    }), ' ', "to") : null, /*#__PURE__*/React.createElement(Chip, {
      className: classes.chip,
      color: "primary",
      label: corrected,
      variant: "success"
    }));
  };
  const getCorrectionDate = date => date ? moment(date).format('L') : 'undefined';
  const getAttributes = (index, trigger, type) => {
    switch (type) {
      case 'ResidentBillingStartDateChanged':
        return {
          corrected: getCorrectionDate(trigger.billingStartDateOnlyNew),
          hasOriginal: true,
          label: "".concat(index + 1, ". Billing start date of ").concat(trigger.firstname, " ").concat(trigger.lastname, " (Unit ").concat(trigger.unitName, ") changed from "),
          original: getCorrectionDate(trigger.billingStartDateOnlyOriginal)
        };
      case 'ResidentEnrolled':
        return {
          corrected: getCorrectionDate(trigger.billingStartDateOnlyNew),
          hasOriginal: false,
          label: "".concat(index + 1, ". Resident ").concat(trigger.firstname, " ").concat(trigger.lastname, " (Unit ").concat(trigger.unitName, ") enrolled on "),
          original: 'undefined'
        };
      case 'ResidentMoveOutDateChanged':
      default:
        return {
          corrected: getCorrectionDate(trigger.moveOutDateOnlyNew),
          hasOriginal: true,
          label: "".concat(index + 1, ". Move-out date of ").concat(trigger.firstname, " ").concat(trigger.lastname, " (Unit ").concat(trigger.unitName, ") changed from "),
          isMoveOut: true,
          original: getCorrectionDate(trigger.moveOutDateOnlyOriginal)
        };
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.correctionTriggersBlock
  }, /*#__PURE__*/React.createElement(Typography, {
    marginBottom: "15px",
    variant: "h5"
  }, "Adjustment reasons"), /*#__PURE__*/React.createElement("div", {
    className: classes.correctionTriggers
  }, correctionTriggers.map((trigger, index) => /*#__PURE__*/React.createElement("div", {
    className: classes.correctionTrigger,
    key: trigger.id
  }, getReason(getAttributes(index, trigger, trigger.correctionTriggerType)))))), /*#__PURE__*/React.createElement(React.Fragment, null, (correctionAllocationCycles || []).map(transformCycles).sort(sortCycles).reduce((acc, item) => {
    const lastGroup = acc[acc.length - 1];
    if (!lastGroup || lastGroup[0].ym !== item.ym) {
      acc.push([item]);
    } else {
      lastGroup.push(item);
    }
    return acc;
  }, []).map(group => {
    return /*#__PURE__*/React.createElement(Accordion, null, /*#__PURE__*/React.createElement(AccordionSummary, {
      expandIcon: /*#__PURE__*/React.createElement(Icon, {
        fontSize: "large",
        type: "arrow-line-down"
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.correctionTriggersBlock
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h5"
    }, monthNames[group[0].month - 1].slice(0, 3), " ", group[0].year))), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement("div", {
      key: group[0].ym
    }, group.map(item => /*#__PURE__*/React.createElement("div", {
      key: item.correctedAllocationCycleId
    }, item.correctionBillingCycles.map(cycle => {
      return /*#__PURE__*/React.createElement("div", {
        key: item.correctedBillingCycleId
      }, cycle.correctionBills.map(bill => {
        var _store$utilityProvide;
        const summaryObj = getSummaryObj(bill);
        const utilityData = getUtility(bill.utilityTypeName);
        return /*#__PURE__*/React.createElement("div", {
          className: classes.accordionWrapper,
          key: bill === null || bill === void 0 ? void 0 : bill.correctedBillId
        }, /*#__PURE__*/React.createElement(Accordion, null, /*#__PURE__*/React.createElement(AccordionSummary, {
          expandIcon: /*#__PURE__*/React.createElement(Icon, {
            fontSize: "large",
            type: "arrow-line-down"
          })
        }, /*#__PURE__*/React.createElement("div", {
          className: classes.billTableHeader
        }, utilityData.icon({
          pattern: 'white',
          svgType: 'static'
        }), /*#__PURE__*/React.createElement("div", {
          className: classes.billTableHeaderTitle
        }, /*#__PURE__*/React.createElement("div", {
          className: classes.utilityProviderDetails
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h5",
          color: "light"
        }, utilityData.title)), /*#__PURE__*/React.createElement(Typography, {
          color: "light",
          variant: "body1"
        }, (_store$utilityProvide = store.utilityProviders.utilities.get(bill.utilityId)) === null || _store$utilityProvide === void 0 ? void 0 : _store$utilityProvide.providerName), /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          color: "light"
        }, t('allocations.allocated_by'), ":", ' ', /*#__PURE__*/React.createElement("b", null, CONSTANTS.ALLOCATION_METHODS.ByOccupancy))))), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement(BillTable, {
          correctionAllocations: [...bill.correctionAllocations, {
            absorption: bill.absorption,
            label: 'Owner absorption',
            residencyId: 'absorption' // for datagrid getRowId requirement
          }]
        }), /*#__PURE__*/React.createElement("div", {
          className: classes.summaryWrapper
        }, /*#__PURE__*/React.createElement("div", {
          className: classes.summaryBlocks
        }, summaries.map(summary => /*#__PURE__*/React.createElement("div", {
          key: summary,
          className: classes.summaryBlock
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h6",
          color: "light"
        }, summary), /*#__PURE__*/React.createElement(Typography, {
          variant: "h5"
        }, summaryObj[summary]))))))));
      }));
    }))))));
  })), correctionSummary && /*#__PURE__*/React.createElement(Accordion, null, /*#__PURE__*/React.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(Icon, {
      fontSize: "large",
      type: "arrow-line-down"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.correctionTriggersBlock
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Adjustment summary"))), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement(SummaryTable, {
    isExcluded: isExcluded,
    residentSummaryEntries: correctionSummary === null || correctionSummary === void 0 ? void 0 : correctionSummary.residentSummaryEntries
  }))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooterStandart
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => handleClose(),
    type: "button",
    variant: "contained",
    'custom-attribute': '512-allocation-utility'
  }, t('general.close'))));
};
export default CorrectionsDetailsTable;